/* Full-width animation sections, including collection content below the product grid. */
(function () {
 'use strict';
 var selector = "smouz-blinds,smouz-curtains,smouz-duple,smouz-eindprofielen,smouz-floors,smouz-grastapijt,smouz-heating,smouz-install,smouz-laminaat,smouz-laminaat-staaltjes,smouz-led-profielen,smouz-level,smouz-ondervloeren,smouz-pleats,smouz-plinten,smouz-pvc,smouz-pvc-staaltjes,smouz-quote,smouz-rollers,smouz-roomdivider-staaltjes,smouz-roomdividers,smouz-rugs,smouz-services,smouz-showroom,smouz-studio,smouz-swatch,smouz-tapijt,smouz-tapijt-staaltjes,smouz-vinyl,smouz-vinyl-staaltjes,smouz-wallmount,smouz-walls,smouz-wandpanelen,smouz-wandpanelen-staaltjes,smouz-weave,smouz-windows,#smouz-parcel-page";
 var frame = 0;
 function set(el, name, value) {
  if (el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value);
 }
 function fit() {
  frame = 0;
  var width = document.documentElement.clientWidth;
  if (!width) return;
  document.querySelectorAll('#content :is(' + selector + ')').forEach(function(el) {
   if (!el.getClientRects().length) return;
   set(el, '--smouz-edge-width', width + 'px');
   var margin = parseFloat(getComputedStyle(el).marginLeft) || 0;
   var left = el.getBoundingClientRect().left + window.scrollX;
   set(el, '--smouz-edge-left', (Math.round((margin - left) * 1000) / 1000) + 'px');
  });
 }
 function schedule() {
  if (!frame) frame = requestAnimationFrame(fit);
 }
 window.addEventListener('resize', schedule, {passive:true});
 window.addEventListener('load', schedule, {once:true});
 document.addEventListener('shopify:section:load', schedule);
 if (document.fonts) document.fonts.ready.then(schedule);
 if (window.ResizeObserver) new ResizeObserver(schedule).observe(document.documentElement);
 fit();
})();
